import React, { Fragment } from "react";
import TopCreators from "./creators/TopCreators";
import { DownloadAppPopUp } from "./DownloadAppPopUp";
import useStore from "../../states/store";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";
import { Head } from "@inertiajs/react";
import BannerCarousel from "../../components/Banner/BannerCarousel";
import { DEFAULT_BANNER_LIST } from './../../config/banner';

const HomePage = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const [{ showDownloadPopUp }] = useStore();

  const isPWA = () => {
    return (
      (window.navigator.standalone === true) || // For iOS
      (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) // For other platforms
    );
  };

  return (
    <Fragment>
      <Head>
        <title>The #1 Free Platform for SFW & NSFW Collabs!</title>
        <meta name="description" content="Are you a creator looking to meet creators for collaborations? WannaCollab is the best Free network for SFW and NSFW creators to meet for collabs!" />
      </Head>
      <BannerCarousel banners={DEFAULT_BANNER_LIST} />
      <TopCreators />
      {(showDownloadPopUp && isXs && !isPWA()) && <DownloadAppPopUp />}
      {/* {import.meta.env.VITE_APP_ENV == 'LOCAL' && <Tester />} */}
    </Fragment>
  );
};

export default HomePage;
